export default __webpack_public_path__ + "static/media/mail_icon.17a6741c.svg";